// The layout's inline `I18n.translations = ...;` tag and view scripts mutate
// this same i18n-js singleton, so it has to live on the window.
import I18n from "i18n-js";

window.I18n = I18n;
